<a href="" 
    class="text-button-default sg-heading__h4 font-weight-normal"
    [class.text-uppercase]="uppercase"
    [class.text-button-default__light]="color === 'light'"
    #aTag 
    [routerLink]="url">{{label}} <mlp-ng-icon *ngIf="icon" [name]="icon"></mlp-ng-icon></a>
